import { render, staticRenderFns } from "./VideoContainer.vue?vue&type=template&id=1478ae30&scoped=true"
import script from "./VideoContainer.vue?vue&type=script&lang=js"
export * from "./VideoContainer.vue?vue&type=script&lang=js"
import style0 from "./VideoContainer.vue?vue&type=style&index=0&id=1478ae30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478ae30",
  null
  
)

export default component.exports